export default "__VITE_ASSET__DFwkYeom__"